import React, { LegacyRef, ReactNode, forwardRef } from 'react';
import classNames from 'classnames';
import { CloseOutlined } from '@easyv/react-icons';
import { ButtonProps, Modal, ModalProps } from '@easyv/react-components';
import { ProButton } from '@/UIGenerator';

export type ProModalProp = Omit<ModalProps, 'okButtonProps' | 'cancelButtonProps' | 'footer'> & {
  titleClassName?: string;
  showFooter?: boolean;
  hideCancel?: boolean;
  textInFooter?: ReactNode;
  footClassname?: string;
  children: ReactNode;
  closable?: boolean;
  buttonSize?: ButtonProps['size'];
  okBtnType?: 'default' | 'primary' | 'secondary' | 'dashed' | 'text' | 'outline';
  okBtnStatus?: 'default' | 'success' | 'warning' | 'danger' | undefined;
  okBtnDisabled?: boolean;
  onOk?: (e: Event | MouseEvent | undefined) => void;
  onCancel?: () => void;
};

export const ProModal = forwardRef((props: ProModalProp, ref: LegacyRef<HTMLDivElement>) => {
  const {
    titleClassName,
    confirmLoading,
    textInFooter,
    footClassname,
    showFooter = true,
    hideCancel = false,
    okBtnType = 'primary',
    okBtnStatus,
    title,
    closeIcon,
    buttonSize = 'small',
    okBtnDisabled = false,
    ...restProps
  } = props;
  return (
    <Modal
      simple
      className='!rounded-lg'
      style={{ width: 480 }}
      title={title ? <div className={titleClassName}>{title}</div> : null}
      closeIcon={closeIcon || <CloseOutlined className='text-content3' size={14} />}
      {...restProps}
      footer={
        showFooter ? (
          <div className={classNames('flex justify-between', footClassname)}>
            <div className='flex items-center'>{textInFooter}</div>
            <div className='flex'>
              {!hideCancel && (
                <ProButton size={buttonSize} onClick={props.onCancel}>
                  {props.cancelText || '取消'}
                </ProButton>
              )}
              <ProButton
                size={buttonSize}
                loading={confirmLoading}
                type={okBtnType}
                status={okBtnStatus}
                disabled={okBtnDisabled}
                onClick={props.onOk}
              >
                {props.okText || '确定'}
              </ProButton>
            </div>
          </div>
        ) : null
      }
    >
      <div ref={ref}>
        {/* content */}
        {props.children}
      </div>
    </Modal>
  );
});
